import { Cell, MiniGrid, MiniGridRow, Stub } from '@direct-frontend/components';
import styles from './CharacteristicValuesList.module.css';

export function CharacteristicValuesListStub() {
    return (
        <MiniGrid>
            {Array.from({ length: 3 }, (_, index) => (
                <MiniGridRow id={`characteristic-values-stub-${index}`} key={index}>
                    <Cell width="full">
                        <Stub width="100%" height={20} />
                    </Cell>
                    <Cell type="Icon" isGrowable={false} className={styles.cellButtonOpen}>
                        <Stub width={20} height={20} />
                    </Cell>
                </MiniGridRow>
            ))}
        </MiniGrid>
    );
}
